import styled from "styled-components";

import { device } from "../../config/sizes";

export const MenuWrapper = styled.div<{
  isVisible?: boolean;
  background?: string;
}>`
  position: absolute;
  z-index: 10;
  width: 100%;
  height: 100%;
  background-color: ${({ background }) => (background)};
  display: ${({ isVisible }) => (!isVisible ? "none" : "block")};
`;

export const MenuItems = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.35rem;

  @media ${device.tablet} {
    font-size: 1rem;
  }

  ul {
    display: flex;
    justify-content: space-evenly;
    flex-direction: column;
    list-style: none;
    height: 70vh;
    padding: 0;
    margin: 0;
  }

  strong > a {
    font-weight: 700;
    text-decoration: underline;
  }

  a {
    text-decoration: none;
    color: black;
    font-family: "Space Mono", Courier New, monospace;
    font-size: 1.25em;
    font-weight: 500;
  }
`;

export const BurgerWrapper = styled.div`
  opacity: 0.25;
  text-align: right;
  display: flex;
  justify-content: center;

  @media ${device.tablet} {
    img {
      width: 30px;
    }
  }
`;
